__turbopack_context__.v({
  "btnMark": "Calendly-module-scss-module__cJCn8W__btnMark",
  "fadeInOut": "Calendly-module-scss-module__cJCn8W__fadeInOut",
});
